import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Card } from './card.component';

@NgModule({
  providers: [],
  exports: [Card],
  declarations: [Card],
  imports: [CommonModule],
})
export class CardModule {
  constructor() {
  }
}
